// src/features/notifications/notificationsApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const notificationsApi = createApi({
  reducerPath: "notificationsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + `communication/notifications`,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().userSlice?.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Notification"],
  endpoints: (builder) => ({
    getNotifications: builder.query({
      query: ({ page = 1, limit = 20, onlyUnread = false }) =>
        `?page=${page}&limit=${limit}&onlyUnread=${onlyUnread}`,
      transformResponse: (response) => response.data.data, // 👈 extract the array
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({ type: "Notification", id: _id })),
              { type: "Notification", id: "LIST" },
            ]
          : [{ type: "Notification", id: "LIST" }],
    }),
    markAsRead: builder.mutation({
      query: (notificationId) => ({
        url: `/${notificationId}/read`,
        method: "PATCH",
      }),
      invalidatesTags: (result, error, id) => [{ type: "Notification", id }],
    }),
    markAllAsRead: builder.mutation({
      query: () => ({
        url: `/read-all`,
        method: "PATCH",
      }),
      invalidatesTags: [{ type: "Notification", id: "LIST" }],
    }),
    getUnreadCount: builder.query({
      query: () => "/unread-count",
      providesTags: ["UnreadCount"],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useMarkAsReadMutation,
  useMarkAllAsReadMutation,
  useGetUnreadCountQuery,
} = notificationsApi;
